import React from 'react';
import { TrendingUp, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { createStudentViewPath } from '../../utils/studentRoutes';

const AttendanceCardWidget = ({ attendance, rollNumber }) => {
  const navigate = useNavigate();

  if (!attendance) {
    return <div className="text-gray-500 text-center py-4">No attendance data available</div>;
  }

  return (
    <div>
      <div className="text-4xl font-bold text-gray-900 mb-2">
        {Number(attendance.overallPercentage).toFixed(2)}%
      </div>
      
      {attendance.overallPercentage < 75 && (
        <div className="bg-red-50 border border-red-200 rounded p-2 mb-3">
          <p className="text-red-700 text-sm font-medium">⚠️ Below Required 75%</p>
        </div>
      )}
      
      <div className="space-y-2 text-sm text-gray-600 mb-4">
        <p>Theory: {Number(attendance.theoryPercentage).toFixed(2)}%</p>
        <p>Practical: {Number(attendance.practicalPercentage).toFixed(2)}%</p>
      </div>
      
      <button
        onClick={() => navigate(createStudentViewPath('/student/attendance-report', rollNumber))}
        className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
      >
        <Eye className="w-4 h-4" />
        <span>View Report</span>
      </button>
    </div>
  );
};

export default AttendanceCardWidget;
